import request from '@/utils/request';

interface InterfaceCancelTaskTypeFilter {
  export_module?: number;
  task_type?: number;
}

export const cancelTaskTypeFilter = async (
  params: InterfaceCancelTaskTypeFilter
) => {
  const res = await request.post(
    '/api/v2/apps/basic/reportcenter/cancel_task_type_filter',
    {
      ...params,
    }
  );
  return res;
};

interface InterfaceCreateExportTask {
  export_module: number;
  task_type: number;
  extra_data: string;
}

export const createExportTask = async (params: InterfaceCreateExportTask) => {
  const res = await request.post(
    '/api/v2/apps/basic/reportcenter/create_export_task',
    {
      ...params,
    }
  );
  return res;
};

//rt inbound 导出新接口

export const createRTInboundExportTask = async (
  params: InterfaceCreateExportTask
) => {
  const res = await request.post(
    '/api/apps/returninboundexport/create_export_task',
    {
      ...params,
    }
  );
  return res;
};

interface InterfaceCreateTaskTypeFilter {
  export_module?: number;
  task_type?: number;
}

export const createTaskTypeFilter = async (
  params: InterfaceCreateTaskTypeFilter
) => {
  const res = await request.post(
    '/api/v2/apps/basic/reportcenter/create_task_type_filter',
    {
      ...params,
    }
  );
  return res;
};

export const getAvailableModule = async () => {
  const res = await request.get(
    '/api/v2/apps/basic/reportcenter/get_available_module',
    {
      params: {},
    }
  );
  return res;
};

interface InterfaceGetAvailableTaskTypeByModule {
  export_module: number;
}

export const getAvailableTaskTypeByModule = async (
  params: InterfaceGetAvailableTaskTypeByModule
) => {
  const res = await request.get(
    '/api/v2/apps/basic/reportcenter/get_available_task_type_by_module',
    {
      params: {
        ...params,
      },
    }
  );
  return res;
};

export const getTaskTypeFilter = async () => {
  const res = await request.get(
    '/api/v2/apps/basic/reportcenter/get_task_type_filter',
    {
      params: {},
    }
  );
  return res;
};

interface InterfaceRetryExportTask {
  task_id: string;
}

export const retryExportTask = async (params: InterfaceRetryExportTask) => {
  const res = await request.post(
    '/api/v2/apps/basic/reportcenter/retry_export_task',
    {
      ...params,
    }
  );
  return res;
};

export const retryRTInboundExportTask = async (
  params: InterfaceRetryExportTask
) => {
  const res = await request.post(
    '/api/apps/returninboundexport/retry_export_task',
    {
      ...params,
    }
  );
  return res;
};

interface InterfaceSearchExportTask {
  export_module?: number;
  task_type?: number;
  task_id?: string;
  creator?: string;
  task_status?: number;
  is_myself?: number;
  pageno?: number;
  count?: number;
  start_time?: number;
  end_time?: number;
}

export const searchExportTask = async (params: InterfaceSearchExportTask) => {
  const res = await request.get(
    '/api/v2/apps/basic/reportcenter/search_export_task',
    {
      params: {
        ...params,
      },
    }
  );
  return res;
};

interface InterfaceSearchASNReportTask {
  inbound_id?: string;
  task_status?: number;
  order_no?: string;
  group_id?: string;
  supplier_id?: string;
  date_reference?: number;
  time_from?: number;
  time_to?: number;
  pageno?: number;
  count?: number;
}

export const searchASNReport = async (params: InterfaceSearchASNReportTask) => {
  const res = await request.get(
    '/api/v2/apps/process/inbound/poasnreport/search_asn_report',
    {
      params: {
        ...params,
      },
    }
  );
  return res;
};

interface InterfaceSearchASNSKUReportTask {
  sku_id?: string;
  task_status?: number;
  order_no?: string;
  group_id?: string;
  supplier_id?: string;
  date_reference?: number;
  time_from?: number;
  time_to?: number;
  pageno?: number;
  count?: number;
}

export const searchASNSKUReport = async (
  params: InterfaceSearchASNSKUReportTask
) => {
  const res = await request.get(
    '/api/v2/apps/process/inbound/poasnskureport/search_asn_sku_report',
    {
      params: {
        ...params,
      },
    }
  );
  return res;
};
